export default "__VITE_ASSET__CWMJWogg__"